<template>
  <div class="nx-scenarios" v-if="scenarios">
    <!-- 背景装饰 -->
    <div class="nx-scenarios-bg">
      <div class="nx-scenarios-glow nx-glow-blue"></div>
      <div class="nx-scenarios-glow nx-glow-cyan"></div>
      <div class="nx-scenarios-grid"></div>
    </div>

    <div class="nx-scenarios-container">
      <!-- 板块标题 -->
      <div class="nx-scenarios-header nx-animate-on-scroll">
        <p class="nx-scenarios-subtitle">{{ scenarios.subtitle }}</p>
        <h2 class="nx-scenarios-title">{{ scenarios.title }}</h2>
        <p class="nx-scenarios-desc">{{ scenarios.description }}</p>
      </div>

      <!-- 更多按钮（参考公司动态） -->
      <div class="nx-scenarios-more">
        <a href="javascript:void(0)" class="nx-scenarios-more-btn" @click="goList">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 17L18 12L13 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 17L11 12L6 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

      <!-- 场景目录卡片 -->
      <div class="nx-scenario-grid">
        <div
          v-for="(item, idx) in previewScenarios"
          :key="item.id || idx"
          class="nx-scenario-card nx-animate-on-scroll"
          :style="getCardDelay(idx)"
          @click="openScenario(item)"
        >
          <!-- 水印序号 -->
          <div class="nx-scenario-watermark">{{ item.index }}</div>

          <!-- 头部：序号徽章 + 标签 -->
          <div class="nx-scenario-top">
            <div class="nx-scenario-index-chip">
              <span class="nx-chip-label">场景</span>
              <span class="nx-chip-num">{{ item.index }}</span>
            </div>
            <span class="nx-scenario-badge" v-if="item.badge">{{ item.badge }}</span>
          </div>

          <!-- 名称与标语 -->
          <h3 class="nx-scenario-name">{{ item.name }}</h3>
          <p class="nx-scenario-tagline">{{ item.tagline }}</p>

          <!-- 摘要 -->
          <p class="nx-scenario-summary">{{ item.summary }}</p>

          <!-- 能力链条 -->
          <div class="nx-scenario-chain" v-if="item.chain && item.chain.length">
            <span class="nx-chain-item" v-for="(part, i) in item.chain" :key="i">
              {{ part }}
              <i class="nx-chain-dot" v-if="i < item.chain.length - 1"></i>
            </span>
          </div>

          <!-- 底部：查看详情 -->
          <div class="nx-scenario-more">
            <span class="nx-more-text">查看详情</span>
            <svg class="nx-more-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NxScenarios',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  computed: {
    scenarios() {
      return this.config?.products?.highValueScenarios || null;
    },
    previewScenarios() {
      const items = this.scenarios?.items || [];
      return items.slice(0, 2);
    }
  },
  methods: {
    getCardDelay(idx) {
      return { transitionDelay: idx * 0.1 + 's', animationDelay: idx * 0.1 + 's' };
    },
    openScenario(item) {
      if (!item?.id) return;
      // 在新标签页打开场景详情页
      window.open('/scenario-detail?id=' + encodeURIComponent(item.id), '_blank');
    },
    goList() {
      // 在新标签页打开高价值场景列表页
      window.open('/scenarios', '_blank');
    }
  }
};
</script>

<style scoped>
/* ============ 高价值场景目录 - 浅蓝清新主题（与首页统一） ============ */
.nx-scenarios {
  position: relative;
  padding: 110px 30px 120px;
  background: linear-gradient(180deg, #f2f8fe 0%, #e9f3fd 50%, #f4faff 100%);
  overflow: hidden;
  isolation: isolate;
  text-align: left;
}

/* 背景光晕与网格 */
.nx-scenarios-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.nx-scenarios-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
}

.nx-glow-blue {
  width: 620px;
  height: 620px;
  top: -240px;
  right: -140px;
  background: radial-gradient(circle, rgba(25, 118, 210, 0.1) 0%, transparent 65%);
  animation: glowDrift 14s ease-in-out infinite alternate;
}

.nx-glow-cyan {
  width: 560px;
  height: 560px;
  bottom: -220px;
  left: -160px;
  background: radial-gradient(circle, rgba(0, 188, 212, 0.08) 0%, transparent 65%);
  animation: glowDrift 16s ease-in-out infinite alternate-reverse;
}

@keyframes glowDrift {
  0% { transform: translate(0, 0) scale(1); opacity: 0.75; }
  100% { transform: translate(-40px, 30px) scale(1.12); opacity: 1; }
}

.nx-scenarios-grid {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(25, 118, 210, 0.035) 1px, transparent 1px),
    linear-gradient(rgba(25, 118, 210, 0.035) 1px, transparent 1px);
  background-size: 70px 70px;
  mask-image: radial-gradient(ellipse 90% 70% at 50% 40%, #000 30%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 90% 70% at 50% 40%, #000 30%, transparent 100%);
}

.nx-scenarios-container {
  max-width: 1240px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* 标题 - 与首页各板块统一 */
.nx-scenarios-header {
  text-align: center;
  margin-bottom: 56px;
}

.nx-scenarios-subtitle {
  font-size: 1.05rem;
  color: var(--nx-blue-primary, #1976d2);
  font-weight: 500;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
  text-shadow: 0 0 20px rgba(25, 118, 210, 0.25);
}

.nx-scenarios-title {
  font-size: clamp(30px, 4vw, 44px);
  font-weight: 800;
  color: var(--nx-text-title, #455a64);
  letter-spacing: 0.06em;
  margin-bottom: 16px;
  position: relative;
  display: inline-block;
  text-shadow: 0 0 30px rgba(13, 71, 161, 0.15);
}

.nx-scenarios-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, transparent, #1976d2 35%, #00bcd4 65%, transparent);
  box-shadow: 0 0 15px rgba(25, 118, 210, 0.6);
}

.nx-scenarios-desc {
  max-width: 760px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.9;
  color: var(--nx-text-desc, #546e7a);
}

/* ============ 目录卡片 ============ */
.nx-scenario-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(460px, 1fr));
  gap: 26px;
}

.nx-scenario-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: var(--nx-radius-md, 18px);
  padding: 36px 38px 30px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 255, 0.95) 100%);
  backdrop-filter: blur(30px);
  border: 2px solid rgba(25, 118, 210, 0.15);
  box-shadow:
    0 8px 30px rgba(21, 101, 192, 0.12),
    0 0 40px rgba(21, 101, 192, 0.06);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.55s cubic-bezier(0.23, 1, 0.32, 1), border-color 0.45s ease, box-shadow 0.55s ease;
  animation: scenarioRise 0.9s cubic-bezier(0.23, 1, 0.32, 1) backwards;
}

@keyframes scenarioRise {
  0% { opacity: 0; transform: translateY(46px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* 顶部流光 */
.nx-scenario-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #1976d2 30%, #42a5f5 55%, #00bcd4 80%, transparent 100%);
  background-size: 200% 100%;
  animation: topBeam 5s linear infinite;
  opacity: 0;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.4s ease;
}

@keyframes topBeam {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* 角标装饰 */
.nx-scenario-card::after {
  content: '';
  position: absolute;
  top: 14px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-top: 2px solid rgba(25, 118, 210, 0.35);
  border-right: 2px solid rgba(25, 118, 210, 0.35);
  pointer-events: none;
  transition: all 0.45s ease;
}

.nx-scenario-card:hover {
  transform: translateY(-10px) scale(1.01);
  border-color: rgba(25, 118, 210, 0.4);
  box-shadow:
    0 20px 60px rgba(21, 101, 192, 0.2),
    0 0 60px rgba(0, 188, 212, 0.1);
}

.nx-scenario-card:hover::before {
  opacity: 1;
  transform: scaleX(1);
}

.nx-scenario-card:hover::after {
  top: 10px;
  right: 12px;
  border-color: rgba(25, 118, 210, 0.7);
}

/* 水印序号 */
.nx-scenario-watermark {
  position: absolute;
  right: 22px;
  bottom: -26px;
  font-size: 170px;
  font-weight: 900;
  line-height: 1;
  color: transparent;
  -webkit-text-stroke: 1.5px rgba(25, 118, 210, 0.1);
  letter-spacing: -0.04em;
  pointer-events: none;
  user-select: none;
  z-index: 0;
  transition: all 0.55s ease;
}

.nx-scenario-card:hover .nx-scenario-watermark {
  -webkit-text-stroke-color: rgba(25, 118, 210, 0.2);
}

.nx-scenario-card > *:not(.nx-scenario-watermark) {
  position: relative;
  z-index: 1;
}

/* 头部行 */
.nx-scenario-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}

.nx-scenario-index-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.08), rgba(0, 188, 212, 0.08));
  border: 1px solid rgba(25, 118, 210, 0.3);
}

.nx-chip-label {
  font-size: 12px;
  color: #1565c0;
  letter-spacing: 0.2em;
}

.nx-chip-num {
  font-size: 15px;
  font-weight: 800;
  color: #1976d2;
  font-style: italic;
}

.nx-scenario-badge {
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #00838f;
  background: rgba(0, 188, 212, 0.08);
  border: 1px solid rgba(0, 188, 212, 0.35);
  white-space: nowrap;
}

/* 名称与标语 */
.nx-scenario-name {
  font-size: clamp(24px, 2.6vw, 32px);
  font-weight: 800;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
  background: linear-gradient(110deg, #0d47a1 0%, #1976d2 30%, #42a5f5 55%, #1976d2 80%, #0d47a1 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: nameShine 5s linear infinite;
  filter: drop-shadow(0 0 12px rgba(25, 118, 210, 0.25));
  display: inline-block;
}

@keyframes nameShine {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.nx-scenario-tagline {
  font-size: 15px;
  color: #1565c0;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 16px;
}

/* 摘要 */
.nx-scenario-summary {
  font-size: 13.5px;
  line-height: 1.95;
  color: var(--nx-text-desc, #546e7a);
  margin-bottom: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 能力链条 */
.nx-scenario-chain {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 26px;
}

.nx-chain-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #1976d2;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 8px;
  background: rgba(25, 118, 210, 0.05);
  border: 1px solid rgba(25, 118, 210, 0.22);
  letter-spacing: 0.05em;
  transition: all 0.35s ease;
}

.nx-scenario-card:hover .nx-chain-item {
  background: rgba(25, 118, 210, 0.1);
  border-color: rgba(25, 118, 210, 0.38);
}

.nx-chain-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #1976d2;
  box-shadow: 0 0 6px rgba(25, 118, 210, 0.6);
}

/* 更多按钮（与公司动态一致） */
.nx-scenarios-more {
  position: absolute;
  top: 100px;
  right: 0;
  z-index: 10;
}

.nx-scenarios-more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%);
  border: 1.5px solid rgba(25, 118, 210, 0.2);
  color: #1976d2;
  text-decoration: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow:
    0 2px 8px rgba(25, 118, 210, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 0.8);
}

.nx-scenarios-more-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-color: transparent;
  color: #fff;
  transform: translateX(4px);
  box-shadow:
    0 4px 15px rgba(25, 118, 210, 0.25),
    inset 0 0 0 transparent;
}

.nx-scenarios-more-btn svg {
  width: 20px;
  height: 20px;
  display: block;
  transition: transform 0.3s ease;
}

.nx-scenarios-more-btn:hover svg {
  transform: translateX(2px);
}

/* 查看详情（固定在卡片底部，所有卡片位置一致） */
.nx-scenario-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #1976d2;
  transition: all 0.35s ease;
}

.nx-more-arrow {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: #1976d2;
  transition: transform 0.35s ease;
}

.nx-scenario-card:hover .nx-scenario-more {
  color: #1565c0;
  text-shadow: 0 0 16px rgba(25, 118, 210, 0.35);
}

.nx-scenario-card:hover .nx-more-arrow {
  transform: translateX(4px);
}

/* ============ 响应式 ============ */
@media (max-width: 1100px) {
  .nx-scenario-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .nx-scenarios {
    padding: 76px 20px 84px;
  }

  .nx-scenarios-header {
    margin-bottom: 40px;
  }

  /* 更多按钮移到描述文字下方，避免与文字重叠 */
  .nx-scenarios-more {
    position: static;
    display: flex;
    justify-content: flex-end;
    margin: -10px 0 18px;
  }

  .nx-scenario-grid {
    gap: 18px;
  }

  .nx-scenario-card {
    padding: 28px 22px 24px;
    border-radius: 14px;
  }

  .nx-scenario-watermark {
    font-size: 120px;
    bottom: -18px;
    right: 8px;
  }

  .nx-scenario-name {
    font-size: 22px;
  }

  .nx-scenario-top {
    margin-bottom: 16px;
  }

  .nx-scenario-chain {
    margin-bottom: 20px;
    gap: 6px;
  }

  .nx-chain-item {
    font-size: 11.5px;
    padding: 5px 9px;
  }

  /* 更多按钮改小（与公司动态一致） */
  .nx-scenarios-more-btn {
    padding: 8px 14px;
  }

  .nx-scenarios-more-btn svg {
    width: 16px;
    height: 16px;
  }
}
</style>
